import { Glitch } from "./index1"

import LandingNav from "./index2"



export const LandingPage=()=>{

    return(
        <div
        
        >
       <div>
           <LandingNav/>
       </div>
       <div>
           <Glitch/>
       </div>
        </div>
    )
}